import LocalizedStrings from 'react-localization';
import en from './en';

export default new LocalizedStrings({
    en: en,
});




// WEBPACK FOOTER //
// ./src/l10n/localization.js